// extracted by mini-css-extract-plugin
export default {"titleWrapper":"mgMjJ","descriptionWrapper":"QJfQ1"};